module.exports = __webpack_public_path__ + "static/media/cloud-sun.b8c379bc.svg";